// hook-command-list-from-entries.ts
//
// Runtime-safe helper dùng chung cho mọi chỗ đọc settings.json / manifest hook
// entries theo shape { matcher?, hooks?: [{ command? }] }. JSON.parse có thể
// thành công dù SHAPE SAI (vd hooks.PreToolUse: "abc" thay vì array — file tay
// sửa hoặc hỏng) → luôn coi input không đúng dạng mảng là "không có gì" (empty),
// KHÔNG throw TypeError. 1 tool méo JSON không được phép làm sập
// checkEnabledToolsHealth khiến MỌI tool khác trong batch báo fail theo.
export function commandsInEntries(entries: unknown): string[] {
  if (!Array.isArray(entries)) return [];
  const out: string[] = [];
  for (const entry of entries) {
    const hooks = (entry as { hooks?: unknown } | null)?.hooks;
    if (!Array.isArray(hooks)) continue;
    for (const h of hooks) {
      const cmd = (h as { command?: unknown } | null)?.command;
      if (typeof cmd === "string") out.push(cmd);
    }
  }
  return out;
}
